import { render, staticRenderFns } from "./ChatGroupListItem.vue?vue&type=template&id=226ba418&scoped=true"
import script from "./ChatGroupListItem.vue?vue&type=script&lang=js"
export * from "./ChatGroupListItem.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupListItem.vue?vue&type=style&index=0&id=226ba418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226ba418",
  null
  
)

export default component.exports